module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<%\n// init\nconst data = rowResourceData || {}\nconst attributes = data.attributes || {}\nattributes.job = attributes.job || {}\nattributes.employee = attributes.employee || {}\nattributes.employeeJob = attributes.employeeJob || {}\nattributes.contractor = attributes.contractor || {}\nattributes.projectTermJobStatus = attributes.projectTermJobStatus || {}\nconst baseMessageKey = 'table.projectTermJobs.fields.status'\nconst messageKeys = []\nconst finalStatus = {\nicon: '',\nstatusClass: '',\nmessageKey: ''\n}\n// check status\nconst status = {\nprojectTermJobReady:        (attributes.jobID && attributes.startTS && attributes.endTS && attributes.duration > 0 && (attributes.employeeID || attributes.contractorID)),\njobReady:                   attributes.job.active,\nworkerActive:               ((attributes.employee.employeeID && attributes.employee.status === 'active') || (attributes.contractor.contractorID && attributes.contractor.status === 'active')),\nworkerCapable:              (attributes.contractor.contractorID || attributes.employeeJob.employeeJobID),\n}\n// define status dependent icon and message\nif(!status.projectTermJobReady || !status.jobReady || !status.workerActive || !status.workerCapable){\nfinalStatus.icon        = finalStatus.icon || 'fi fi-exclamation-triangle'\nfinalStatus.statusClass = finalStatus.statusClass || 'error'\nif(!status.projectTermJobReady)                 messageKeys.push(`${baseMessageKey}.not.projectTermJobReady`);\nif(!status.jobReady)                            messageKeys.push(`${baseMessageKey}.not.jobReady`);\nif(!status.workerActive)                        messageKeys.push(`${baseMessageKey}.not.workerActive`);\nif(status.jobReady && !status.workerCapable)    messageKeys.push(`${baseMessageKey}.not.workerCapable`);\n}\nif(attributes.employee.employeeID){\nif(!attributes.projectTermJobStatus.ts || attributes.projectTermJobStatus.statusOutDated){\nfinalStatus.icon        = finalStatus.icon || `fi fi-employee-${attributes.employee.type}`\nfinalStatus.statusClass = finalStatus.statusClass || 'warning'\n}\nif(!attributes.projectTermJobStatus.ts)                     messageKeys.push(`${baseMessageKey}.not.read`);\nelse if(attributes.projectTermJobStatus.statusOutDated)     messageKeys.push(`${baseMessageKey}.readOutDated`);\n}\nif(messageKeys.length > 0){\nfinalStatus.message = messageKeys.map(key => storage.__(key)).join('\\n')\n} else {\nfinalStatus.icon = 'fi fi-check'\nfinalStatus.statusClass = 'ok'\nfinalStatus.message = storage.__(`${baseMessageKey}.ok`)\n}\n// define style\nconst additionalClasses = []\nif(finalStatus.statusClass){\nadditionalClasses.push(`status_${finalStatus.statusClass}`)\n}\nconst additionalAttributes = []\nif(additionalClasses.length > 0){\nadditionalAttributes.push(`class=\"${additionalClasses.join(' ')}\"`)\n}\nif(finalStatus.message){\nadditionalAttributes.push(`title=\"${finalStatus.message}\"`)\n}\n%><div <%- additionalAttributes.join(' ')%>><%\nif(finalStatus.icon){\n%><i class=\"<%= finalStatus.icon %>\"></i><%\n}\n%></div>"
  , __filename = "components/templates/customers/projectTermJobs/tableFields/status.ejs";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 
// init
const data = rowResourceData || {}
const attributes = data.attributes || {}
attributes.job = attributes.job || {}
attributes.employee = attributes.employee || {}
attributes.employeeJob = attributes.employeeJob || {}
attributes.contractor = attributes.contractor || {}
attributes.projectTermJobStatus = attributes.projectTermJobStatus || {}
const baseMessageKey = 'table.projectTermJobs.fields.status'
const messageKeys = []
const finalStatus = {
icon: '',
statusClass: '',
messageKey: ''
}
// check status
const status = {
projectTermJobReady:        (attributes.jobID && attributes.startTS && attributes.endTS && attributes.duration > 0 && (attributes.employeeID || attributes.contractorID)),
jobReady:                   attributes.job.active,
workerActive:               ((attributes.employee.employeeID && attributes.employee.status === 'active') || (attributes.contractor.contractorID && attributes.contractor.status === 'active')),
workerCapable:              (attributes.contractor.contractorID || attributes.employeeJob.employeeJobID),
}
// define status dependent icon and message
if(!status.projectTermJobReady || !status.jobReady || !status.workerActive || !status.workerCapable){
finalStatus.icon        = finalStatus.icon || 'fi fi-exclamation-triangle'
finalStatus.statusClass = finalStatus.statusClass || 'error'
if(!status.projectTermJobReady)                 messageKeys.push(`${baseMessageKey}.not.projectTermJobReady`);
if(!status.jobReady)                            messageKeys.push(`${baseMessageKey}.not.jobReady`);
if(!status.workerActive)                        messageKeys.push(`${baseMessageKey}.not.workerActive`);
if(status.jobReady && !status.workerCapable)    messageKeys.push(`${baseMessageKey}.not.workerCapable`);
}
if(attributes.employee.employeeID){
if(!attributes.projectTermJobStatus.ts || attributes.projectTermJobStatus.statusOutDated){
finalStatus.icon        = finalStatus.icon || `fi fi-employee-${attributes.employee.type}`
finalStatus.statusClass = finalStatus.statusClass || 'warning'
}
if(!attributes.projectTermJobStatus.ts)                     messageKeys.push(`${baseMessageKey}.not.read`);
else if(attributes.projectTermJobStatus.statusOutDated)     messageKeys.push(`${baseMessageKey}.readOutDated`);
}
if(messageKeys.length > 0){
finalStatus.message = messageKeys.map(key => storage.__(key)).join('\n')
} else {
finalStatus.icon = 'fi fi-check'
finalStatus.statusClass = 'ok'
finalStatus.message = storage.__(`${baseMessageKey}.ok`)
}
// define style
const additionalClasses = []
if(finalStatus.statusClass){
additionalClasses.push(`status_${finalStatus.statusClass}`)
}
const additionalAttributes = []
if(additionalClasses.length > 0){
additionalAttributes.push(`class="${additionalClasses.join(' ')}"`)
}
if(finalStatus.message){
additionalAttributes.push(`title="${finalStatus.message}"`)
}

    ; __line = 60
    ; __append("<div ")
    ; __append( additionalAttributes.join(' '))
    ; __append(">")
    ; 
if(finalStatus.icon){

    ; __line = 62
    ; __append("<i class=\"")
    ; __append(escapeFn( finalStatus.icon ))
    ; __append("\"></i>")
    ; 
}

    ; __line = 64
    ; __append("</div>")
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL=components/templates/customers/projectTermJobs/tableFields/status.ejs

}